module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_error-bbb4965a3549ed1cbaa5a8d577eaeb8e.svg";